import { useEffect } from "react";
import { View, Text, ActivityIndicator } from "react-native";
import { useRouter, useLocalSearchParams } from "expo-router";
import { supabase } from "@/lib/supabase/client";

/**
 * Auth Callback Screen
 * Handles deep link redirects from email confirmation
 */
export default function AuthCallbackScreen() {
  const router = useRouter();
  const params = useLocalSearchParams();

  useEffect(() => {
    const handleCallback = async () => {
      try {
        // Get the tokens from URL params
        const accessToken = params.access_token as string;
        const refreshToken = params.refresh_token as string;

        if (accessToken && refreshToken) {
          // Set the session with the tokens
          const { error } = await supabase.auth.setSession({
            access_token: accessToken,
            refresh_token: refreshToken,
          });

          if (error) {
            console.error("Error setting session:", error);
          }
        }

        // Small delay to ensure auth state updates
        setTimeout(() => {
          router.replace("/(tabs)");
        }, 1000);
      } catch (error) {
        console.error("Callback error:", error);
        router.replace("/(auth)/login");
      }
    };

    handleCallback();
  }, [params]);

  return (
    <View className="flex-1 items-center justify-center bg-primary-600">
      <ActivityIndicator size="large" color="#ffffff" />
      <Text className="text-white mt-4 text-lg">Even geduld...</Text>
      <Text className="text-white/70 mt-2">Je wordt ingelogd</Text>
    </View>
  );
}

